// Ordering the region list, and refusing to rank what has not been measured.
//
// worst_burden_hours is a max over per-household burden rows seeded at 0, so a region with
// no burden rows scores 0 — and 0 sorts first in an ascending ranking. The result was 25 of
// 28 real regions displayed above the 3 scored ones, each claiming "0 h door-to-door".
// A region nobody has measured is not the best option; it is an unknown.

/** Just enough of RegionScore to order it. */
export interface RankableRegion {
  worst_burden_hours: number
  per_household: readonly unknown[]
}

/** A region is only ranked once at least one household's travel has been computed. */
export function isScored(region: RankableRegion): boolean {
  return region.per_household.length > 0
}

/** Scored regions ascending by worst-off travel; unscored last, never first. */
export function compareRegions(a: RankableRegion, b: RankableRegion): number {
  const aScored = isScored(a)
  const bScored = isScored(b)
  if (aScored !== bScored) return aScored ? -1 : 1
  if (!aScored) return 0
  return a.worst_burden_hours - b.worst_burden_hours
}
